import { gql, useQuery } from "@apollo/client";

const CalculateBulkClassRoomCreationSlotsQuery = gql`
  query calculateBulkClassRoomCreationSlots(
    $input: CalculateBulkClassRoomCreationSlotsInput!
  ) {
    calculateBulkClassRoomCreationSlots(input: $input) {
      startDateUtc
      endDateUtc
      teacherConflictingClass {
        id
        type
        is1on1
        capacity
        startedAtUtc
        endedAtUtc
        speakingLevel
        userGroup {
          id
          name
        }
        participants {
          id
          givenName
          familyName
        }
      }
      userConflictingClass {
        id
        is1on1
        capacity
        startedAtUtc
        endedAtUtc
        speakingLevel
        userGroup {
          id
          name
        }
        participants {
          id
          givenName
          familyName
        }
      }
    }
  }
`;

export function useCalculateBulkClassRoomCreationSlots(input: {
  teacherId: string;
  studentId?: string;
  startDate: string;
  numberOfWeeks: number;
  maxClassRoomNumber?: number;
  weekSlots: Array<{
    dayOfWeek: number;
    startTime: string;
    endTime: string;
  }>;
  timezone?: string;
  excludedSlots?: string[];
  additionalSlots?: Array<{ startDateUtc: string; endDateUtc: string }>;
}) {
  const { data, loading, error, refetch } = useQuery(
    CalculateBulkClassRoomCreationSlotsQuery,
    {
      variables: { input },
      skip: !input.teacherId || !input.startDate,
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    slots: data?.calculateBulkClassRoomCreationSlots ?? [],
    loading,
    error,
    refetch,
  };
}
